import { render } from "./CollapseTransition.vue?vue&type=template&id=3208976f&scoped=true"
import script from "./CollapseTransition.vue?vue&type=script&lang=js"
export * from "./CollapseTransition.vue?vue&type=script&lang=js"

import "./CollapseTransition.vue?vue&type=style&index=0&id=3208976f&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3208976f"]])

export default __exports__